// extracted by mini-css-extract-plugin
module.exports = {"splash":"App_splash__1Vxrf","item":"App_item__2fAWe","footer":"App_footer__3hZpG"};